import {
  available,
  BPS_DENOMINATOR,
  isPositiveU64,
  isU64,
  PRICE_SCALE_D9,
  unavailable,
} from './integer.js';
import type { PoolMathResult } from './types.js';

export function reserveRatioSpotPriceD9(
  quoteReserveD6: bigint,
  outcomeReserveD6: bigint,
): PoolMathResult<bigint> {
  if (!isPositiveU64(quoteReserveD6) || !isPositiveU64(outcomeReserveD6)) {
    return unavailable('invalid_reserves');
  }
  return available((quoteReserveD6 * PRICE_SCALE_D9) / outcomeReserveD6);
}

/** Net quote paid/received per outcome token for one executable quote. */
export function effectiveExecutionPriceD9(
  quoteAmountD6: bigint,
  outcomeAmountD6: bigint,
): PoolMathResult<bigint> {
  if (!isPositiveU64(quoteAmountD6) || !isPositiveU64(outcomeAmountD6)) {
    return unavailable('invalid_amount');
  }
  const priceD9 = (quoteAmountD6 * PRICE_SCALE_D9) / outcomeAmountD6;
  return isU64(priceD9) ? available(priceD9) : unavailable('invalid_amount');
}

/** Absolute execution-vs-spot distance, capped at 100% (10_000 BPS). */
export function absolutePriceImpactBps(
  executionPriceD9: bigint,
  spotPriceD9: bigint,
): PoolMathResult<bigint> {
  if (!isPositiveU64(executionPriceD9) || !isPositiveU64(spotPriceD9)) {
    return unavailable('invalid_amount');
  }
  const delta =
    executionPriceD9 >= spotPriceD9
      ? executionPriceD9 - spotPriceD9
      : spotPriceD9 - executionPriceD9;
  const impactBps = (delta * BPS_DENOMINATOR) / spotPriceD9;
  return available(impactBps > BPS_DENOMINATOR ? BPS_DENOMINATOR : impactBps);
}
